module.exports = __webpack_public_path__ + "static/media/06.113.f62ababf.webp";